/* eslint-disable react/jsx-pascal-case */
import { Routes, Route } from "react-router-dom";
import { ThemeProvider, createTheme, CssBaseline } from "@mui/material";
import Home from "./FrontEnd/Pages/Home";
import AboutUs from "./FrontEnd/Pages/AboutUs";
import Navbar from "./FrontEnd/Navbar/Navbar";

import Translations from "./FrontEnd/Pages/Translations";
import Transcriptions from "./FrontEnd/Pages/Transcriptions";
import PrivacyPolicy from "./FrontEnd/Components/PrivacyPolicy";
import Book_now from "./FrontEnd/Pages/BookNow";
import Contact_us from "./FrontEnd/Pages/ContactUs";
import Interpreting from "./FrontEnd/Pages/Interpreting";
import i18n from "./i18n";
import "./FrontEnd/fonts/fonts.css";

import { useEffect, useState } from "react";
import LoadingScreen from "./FrontEnd/Components/LoadingScreen";

// Create a modern MUI theme
const theme = createTheme({
  palette: {
    primary: {
      main: "#1976d2",
      light: "#42a5f5",
      dark: "#1565c0",
    },
    secondary: {
      main: "#dc004e",
    },
    background: {
      default: "#ffffff",
      paper: "#f5f5f5",
    },
  },
  typography: {
    fontFamily: [
      "Zain",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
    ].join(","),
    h4: {
      fontWeight: 600,
    },
    h5: {
      fontWeight: 600,
    },
    h6: {
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          borderRadius: 8,
          padding: "10px 24px",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        },
      },
    },
  },
});


function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check localStorage first, then default to "en" if nothing is saved
    const savedLang = localStorage.getItem("i18nextLng") || "en";
    if (savedLang && savedLang !== i18n.language) {
      i18n.changeLanguage(savedLang);
    }

    // Simulate loading time
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <LoadingScreen />
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="AboutUs" element={<AboutUs />} />
        <Route path="Translations" element={<Translations />} />
        <Route path="Transcriptions" element={<Transcriptions />} />
        <Route path="Interpreting" element={<Interpreting />} />
        <Route path="PrivacyPolicy" element={<PrivacyPolicy />} />
        <Route path="Book_now" element={<Book_now />} />
        <Route path="ContactUs" element={<Contact_us />} />
      </Routes>
    </ThemeProvider>
  );
}

export default App;
